import React, { memo, Fragment } from 'react';

import { Grid, Fade } from '@material-ui/core';

import { object, bool, func } from 'prop-types';
import { generate } from 'shortid';

import { SubContainer, BackDropStyled, ListTitle, StyledLink, ListSubCategories, ListItemSubCategorie } from './styles';

const HeaderBackDrop = ({ openMenu, subMenu, handleMenu }) => (
  <Fragment>
    <BackDropStyled open onMouseEnter={handleMenu(false)} />
    <Fade in={openMenu} timeout={750}>
      <SubContainer container>
        <Grid container>
          {subMenu &&
            subMenu.children &&
            subMenu.children.map((sub) => (
              <Grid container item xs={3} key={generate()} direction="column" alignItems="center">
                <ListTitle>
                  <StyledLink href={`${sub.link}`} title={sub.title}>
                    {sub.title}
                  </StyledLink>
                </ListTitle>
                <ListSubCategories>
                  {sub.children.map((item) => (
                    <ListItemSubCategorie key={generate()} background={item.background} fontcolor={item.fontColor}>
                      <StyledLink href={`${item.link}`} title={item.title}>
                        {item.title}
                      </StyledLink>
                    </ListItemSubCategorie>
                  ))}
                </ListSubCategories>
              </Grid>
            ))}
        </Grid>
      </SubContainer>
    </Fade>
  </Fragment>
);

HeaderBackDrop.propTypes = {
  subMenu: object,
  openMenu: bool,
  handleMenu: func,
};

export default memo(HeaderBackDrop);
